import { motion } from 'framer-motion'
import { Card } from '../components/ui/Card'

const container = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.08 } } }
const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }

export const TermsOfService = () => {
  return (
    <motion.div variants={container} initial="hidden" animate="show" className="space-y-8 max-w-4xl mx-auto">
      <motion.div variants={item} className="text-center">
        <h1 className="text-3xl font-bold text-metallic-900">Terms of Service</h1>
        <p className="text-metallic-500 mt-2">Last updated: July 2026</p>
      </motion.div>

      <motion.div variants={item}>
        <Card className="space-y-6">
          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">1. Acceptance of Terms</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              By accessing or using IntelCore Enterprise Intelligence Platform ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service. IntelCore provides AI-powered business intelligence, marketing automation, CRM, web design, branding, security assessment, mobile app development, and Google Maps visibility services.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">2. Service Description</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              IntelCore is an enterprise-grade SaaS platform that provides: (a) Real-time business intelligence dashboards powered by AI analytics, (b) Multi-channel marketing automation across Email, WhatsApp, Telegram, and Social Media, (c) AI-powered chat and voice agents for customer engagement, (d) Customer Relationship Management with pipeline tracking, (e) Professional branding and web design services, (f) Vulnerability assessment and security scanning, (g) Mobile application development, (h) Google Maps and local SEO optimization.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">3. Account Registration</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              You must provide accurate, complete information during registration. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. One account per user. You must be at least 18 years old to use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">4. Subscription Plans & Payment</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              IntelCore offers tiered subscription plans: Starter ($29/month), Professional ($79/month), and Enterprise ($199/month). All payments are processed securely via Paystack. Subscriptions auto-renew unless cancelled. You may upgrade or downgrade your plan at any time. Refund requests are evaluated on a case-by-case basis within 14 days of purchase.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">5. AI-Generated Content</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              The Service uses artificial intelligence (powered by Groq and Llama models) to generate insights, recommendations, marketing content, security analyses, and other outputs. While we strive for accuracy, AI-generated content should be reviewed by qualified professionals before implementation. IntelCore is not liable for decisions made solely based on AI-generated outputs.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">6. Data Usage & Privacy</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              Your data is processed in accordance with our Privacy Policy. By using the Service, you grant IntelCore a limited license to process your data for the purpose of providing and improving the Service. We do not sell your personal data to third parties. All data is stored securely with encryption at rest and in transit.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">7. Acceptable Use</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              You agree not to: (a) Use the Service for any unlawful purpose, (b) Attempt to gain unauthorized access to any part of the Service, (c) Interfere with or disrupt the Service, (d) Use the Service to send spam or unsolicited communications, (e) Reverse engineer or decompile any part of the Service, (f) Resell or redistribute the Service without written consent.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">8. Limitation of Liability</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              To the maximum extent permitted by law, IntelCore shall not be liable for any indirect, incidental, special, consequential, or punitive damages. Our total liability shall not exceed the amount paid by you in the 12 months preceding the claim. The Service is provided "as is" without warranties of any kind.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">9. Termination</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              Either party may terminate this agreement. Upon termination, your access to the Service will cease. We may retain your data for up to 30 days after termination, after which it will be permanently deleted. You may export your data before termination.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-metallic-900 mb-3">10. Changes to Terms</h2>
            <p className="text-metallic-600 text-sm leading-relaxed">
              IntelCore reserves the right to modify these terms at any time. Material changes will be communicated via email or in-app notification. Continued use of the Service after changes constitutes acceptance of the modified terms.
            </p>
          </section>
        </Card>
      </motion.div>
    </motion.div>
  )
}
